import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = 'auto', input = '' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle id="Oval" cx="15" cy="15" r="15" fill="#DCDCDC">
        <text id="textid" x="0" y="15" fill="#000">
          {input}
        </text>
      </circle>
    </svg>
  );
};

export default Icon;
